exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "h1 {\n  font-family: Helvetica, sans-serif;\n  font-size: 15px;\n  text-align: left;\n  float: left;\n  padding-top: 10px;\n  padding-left: 10px;\n  text-transform: uppercase;\n  font-weight: 600;\n  letter-spacing: 2px; }\n\nhr {\n  display: block;\n  overflow: hidden;\n  border-style: solid;\n  border-width: 1px;\n  border-color: #c0c0c0;\n  width: 100%; }\n\n.modal-content {\n  margin-bottom: 20px; }\n\n.right {\n  float: right; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/admin/shared/delete-user/delete-user.component.scss
// module id = 1281
// module chunks = 0